import React, { useEffect, useState } from "react";
import { SearchIcon } from "../common/Icon";
import { createFollowUpPopUpData } from "../common/Helper";
import { useStateProvider } from "../common/StateProvider";
import ProfileCalendarPopUp from "./ProfileCalendarPopUp";

const FollowUpProfilePopUp = () => {
  const [filteredList, setFilteredList] = useState(createFollowUpPopUpData);
  const [inputFilter, setInputFilter] = useState("");
  // const [setActiveCard] = useState(null);
  const { profileCalendar, setProfileCalendar } = useStateProvider();

  const inputChangeHandler = (value) => {
    const filteredData = createFollowUpPopUpData.filter((obj) => {
      return obj.createFollowUpNameText
        .toLowerCase()
        .includes(value.toLowerCase());
    });
    setFilteredList(filteredData);
    setInputFilter(value);
    // setActiveCard(null); // Clear the active card when typing in the input
  };
  const openProfileCalendarModel = () => {
    setProfileCalendar(true);
  };

  // OVERFLOW HIDDEN WHEN FILTER MODEL OPEN
  useEffect(() => {
    if (profileCalendar) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [profileCalendar]);
  return (
    <>
      <div className="rounded-xl border-[(1px_solid_rgba(111,_106,_248,_0.10))] bg-white shadow-todays_workflow_box_shadow pt-[18px] w-[320px] xs:w-[375px] xm:w-[440px] relative">
        <div className="flex border border-solid border-[#929292] ps-4 py-2  items-center rounded-[50px] mx-4 md:mx-5">
          <span className=" opacity-60 pr-3">
            <SearchIcon />
          </span>
          <input
            className="ff_poppins font-normal text-[14px] text-black placeholder:text-black placeholder:opacity-70  bg-transparent placeholder:font-normal pe-[10px] outline-none w-11/12"
            type="text"
            value={inputFilter}
            placeholder="Search here..."
            onChange={(e) => inputChangeHandler(e.target.value)}
          />
        </div>
        <div className=" overflow-y-auto h-[320px] overflow_x_scroll_style">
          {filteredList.map((data, index) => {
            return (
              <div
                onClick={openProfileCalendarModel}
                className={`flex items-center justify-between hover:shadow-workflow_item_card_shadow duration-200 py-[12px] px-[10px] rounded-[6px] cursor-pointer mx-4 ${index === 0  ? "mt-[22px]" : index === 4 ? "mb-1" : "mt-[7px]" }`}
                key={index}>
                <div className="flex items-center">
                  <img
                    className="w-[30px] h-[30px]"
                    src={data.createFollowUpImg}
                    alt="profile"
                  />
                  <p className="mb-0 ms-[11px] font-normal text-[14px] text-black">
                    {data.createFollowUpNameText}
                  </p>
                </div>
                <span className="profile_calander group">{data.svgIcon}</span>
              </div>
            );
          })}
        </div>
        <div className=" absolute top-[-70px] right-0 sm:right-[1%] md:right-[0%] 3xl:right-[0%]  z-[999999999]">
          {profileCalendar && <ProfileCalendarPopUp />}
        </div>
      </div>
    </>
  );
};

export default FollowUpProfilePopUp;
